function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirConditionerColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 496 496",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3DCE0"
    },
    d: "M496,309.6c0,27.2-6.4,48.8-32.8,48.8H32.8C5.6,358.4,0,336.8,0,309.6V186.4 c0-27.2,21.6-48.8,48.8-48.8h398.4c27.2,0,48.8,21.6,48.8,48.8L496,309.6L496,309.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1E3E5"
    },
    d: "M0,186.4c0-27.2,21.6-48.8,48.8-48.8h398.4c27.2,0,48.8,21.6,48.8,48.8"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ECACC"
    },
    d: "M464.8,308.8c0,5.6-4,9.6-9.6,9.6H40.8c-5.6,0-9.6-4-9.6-9.6l0,0c0-5.6,4-9.6,9.6-9.6h414.4 C460.8,299.2,464.8,303.2,464.8,308.8L464.8,308.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7EAAAA"
    },
    d: "M31.2,308.8L31.2,308.8c0-5.6,4-9.6,9.6-9.6h414.4c5.6,0,9.6,4,9.6,9.6l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ECACC"
    },
    d: "M464.8,336c0,5.6-4,9.6-9.6,9.6H40.8c-5.6,0-9.6-4-9.6-9.6l0,0c0-5.6,4-9.6,9.6-9.6h414.4 C460.8,326.4,464.8,330.4,464.8,336L464.8,336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7EAAAA"
    },
    d: "M31.2,336L31.2,336c0-5.6,4-9.6,9.6-9.6h414.4c5.6,0,9.6,4,9.6,9.6l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#46BC5C"
    },
    d: "M145.6,267.2c0,2.4-2.4,4.8-4.8,4.8H39.2c-2.4,0-4.8-2.4-4.8-4.8v-33.6c0-2.4,2.4-4.8,4.8-4.8h102.4 c2.4,0,4.8,2.4,4.8,4.8v33.6H145.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2FA53F"
    },
    d: "M140.8,229.6c2.4,0,4.8,2.4,4.8,4.8V268c0,2.4-2.4,4.8-4.8,4.8H39.2c-2.4,0-4.8-2.4-4.8-4.8"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirConditionerColor);
export default __webpack_public_path__ + "static/media/air_conditioner_color.1871892f011a3186c9dcf5a557c6d285.svg";
export { ForwardRef as ReactComponent };